<template>
    <div>
        <h1>Aminosäuren</h1>
        <p>Aminosäuren besitzen eine saure und eine basische Gruppe. Sie enthalten mindestens eine Carboxylgruppe und mindestens eine Aminogruppe</p>
        <img
            src="@/assets/img/stoffe/aminosauren/allgemeine-struktur.png"
            alt="Allgemeine Struktur der Aminosäuren"
            title="Allgemeine Struktur der Aminosäuren"
            width="256px"
            height="auto"
        /><hr class="chapter-split" />
        <chapter-heading title="Eigenschaften"></chapter-heading>
        <p>
            Natürlich vorkommende Aminosäuren sind L-Alpha Aminosäuren.<br>
            Aminosäuren liegen als Zwitterionen vor.
        </p>
    </div>
</template>

<script>
import ChapterHeading from '../../components/chapterHeading';
export default {
    components: { ChapterHeading },
};
</script>
